import { atomWithReset } from 'jotai/utils';




const notificationAtom = atomWithReset({});


export { notificationAtom };